export function ArrowIcon() {
  return <span aria-hidden="true">↗</span>;
}

export function AppStoreButton({ href, inverse = false }: { href: string; inverse?: boolean }) {
  return (
    <a className={`store-button${inverse ? " store-button--inverse" : ""}`} href={href} target="_blank" rel="noreferrer">
      <span className="apple-mark" aria-hidden="true"></span>
      <span><small>Download on the</small><strong>App Store</strong></span>
    </a>
  );
}
